module.exports = __webpack_public_path__ + "img/bot_yf3.4f69b94b.png";